<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="app" :class="vueAppClasses">
    <NetworkStatusBanner />
    <router-view @setAppClasses="setAppClasses" />
    <!-- <VersionUpdateToast
      :visible="showVersionToast"
      @dismiss="showVersionToast = false"
    /> -->
  </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import { pusher } from "@/constants/pusher";
import VersionUpdateToast from '@/components/VersionUpdateToast.vue'
import NetworkStatusBanner from '@/components/NetworkStatusBanner.vue'

export default {
  components: { VersionUpdateToast, NetworkStatusBanner },
  data () {
    return {
      vueAppClasses: [],
      currentVersion: null,
      showVersionToast: false
    }
  },
  watch: {
    '$store.state.theme' (val) {
      this.toggleClassInBody(val)
      this.loadSyncfusionTheme(val)
    },
    '$vs.rtl' (val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    }
  },
  methods: {
    loadSyncfusionTheme (theme) {
      if (theme === 'dark') {
        import('../node_modules/@syncfusion/ej2-navigations/styles/fabric-dark.css')
      } else {
        import('../node_modules/@syncfusion/ej2-navigations/styles/fabric.css')
      }
    },
    toggleClassInBody (className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses (classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize () {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
      this.$store.commit('UPDATE_WINDOW_HEIGHT', window.innerHeight)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    handleScroll () {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    },
    async fetchVersion() {
      try {
        const res = await fetch('/version.json', { cache: 'no-cache' });
        const data = await res.json();
        this.currentVersion = data.version;
      } catch (err) {
        console.error('Error fetching version:', err);
      }
    },
    async checkVersion() {
      try {
        const res = await fetch('/version.json', { cache: 'no-cache' });
        const data = await res.json();
        if (this.currentVersion && data.version !== this.currentVersion) {
          this.showVersionToast = true;
        }
      } catch (err) {
        console.error('Version check failed', err);
      }
    }
  },
  mounted () {
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
    this.$store.commit('UPDATE_WINDOW_HEIGHT', window.innerHeight)

    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  },
  async created () {
    const dir = this.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)

    this.loadSyncfusionTheme(this.$store.state.theme)

    // pusher for builds
    const channel = pusher.subscribe(`new-build`);
    const callback = (eventName, data) => {
      if(data.refresh) {
        location.reload()
      }
    };
    channel.bind_global(callback);

    this.fetchVersion();
    this.versionInterval = setInterval(this.checkVersion, 60000);
  },
  destroyed () {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    clearInterval(this.versionInterval);
  },
}

</script>

<style>
@import "../node_modules/@syncfusion/ej2-base/styles/fabric.css";
@import "../node_modules/@syncfusion/ej2-vue-navigations/styles/fabric.css";
@import "../node_modules/@syncfusion/ej2-inputs/styles/fabric.css";
@import "../node_modules/@syncfusion/ej2-buttons/styles/fabric.css";
@import '../node_modules/@syncfusion/ej2-calendars/styles/fabric.css';
@import '../node_modules/@syncfusion/ej2-dropdowns/styles/fabric.css';
@import '../node_modules/@syncfusion/ej2-popups/styles/fabric.css';
@import '../node_modules/@syncfusion/ej2-vue-schedule/styles/fabric.css';
</style>
